<template>
  <el-main class="container">
    <Nav>
      <div
        slot="left"
        class="left">
        <el-input
          v-model.trim="body.word"
          placeholder="请输入订单号/预约人姓名搜索"
          clearable
          class="input-text"
          maxlength="30"
          ></el-input>
        <el-button type="primary" @click="event().search()">搜索</el-button>

        <div class="industry-box">
          <span>产业筛选</span>
          <el-select v-model="selectIndustry" @change="handleIndustry()" clearable placeholder="请选择产业">
            <el-option
              v-for="item in industryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div
        class="right"
        slot="right">
        <el-button v-show="hasAuthority('meetingExcel')" type="primary" @click="network().appointmentExcel()">导出Excel</el-button>
      </div>
    </Nav>
    <div class="type-change-box">
      <div class="box-name" v-for="(item,index) in titleBox" :key="index">
        <span
          :class="[item.select ? 'black' : '']"
          @click="event().changeStatus(item)">{{item.name}}</span>
      </div>
    </div>

    <table-pagination
      ref="table"
      :config="config"
      :datasource="datasource"
      class="table"
      @change-page="handlerPageChange">
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        width="250"
        align="center">
        <template slot-scope="scope">
            <div class="row" v-show="hasAuthority('auditMeeting')">
              <el-link :underline="false" type='primary' class="details" v-if="scope.row.status === 0 " @click="event().putMeetingAppointment(1,scope)">通过</el-link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <el-link :underline="false" type='primary' class="details" v-if="scope.row.status === 0 " @click="event().putMeetingAppointment(4,scope)">拒绝</el-link>
            </div>
            <div class="row">
              <el-link v-show="hasAuthority('meetingDetail')" :underline="false" type='primary' class="details" @click="handlerPage('get',scope)">查看详情</el-link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <el-link v-show="hasAuthority('meetingInvoice')" :underline="false" type='primary' class="details" v-if="scope.row.isInvoice === 1" @click="hanlderInvoicing(scope.row)">开票信息</el-link>
            </div>
        </template>
      </el-table-column>
    </table-pagination>
    <el-dialog
      :visible.sync="showInvoiceDialog"
      width="600px"
    >
      <div class="dialog-content">
        <div class="title">开票信息</div>
        <div class="person" v-if="invoiceInfo.type === 0">
          <div class="row">
            <div class="item">
              <div class="name">订单编号:</div>
              <div class="val">{{invoiceInfo.orderNum}}</div>
            </div>
            <div class="item">
              <div class="name">下单时间:</div>
              <div class="val">{{invoiceInfo.createTime}}</div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="name">发票类型:</div>
              <div class="val">普通发票</div>
            </div>
            <div class="item">
              <div class="name">发票内容:</div>
              <div class="val">*物业服务*会议室预定</div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="name">发票抬头:</div>
              <div class="val">个人</div>
            </div>
            <div class="item">
              <div class="name">收票人:</div>
              <div class="val">{{invoiceInfo.name}}</div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="name">联系电话:</div>
              <div class="val">{{invoiceInfo.mobile}}</div>
            </div>
          </div>
        </div>
        <div class="company" v-else-if="invoiceInfo.type === 1">
          <div class="row">
            <div class="item">
              <div class="name">订单编号:</div>
              <div class="val">{{invoiceInfo.orderNum}}</div>
            </div>
            <div class="item">
              <div class="name">下单时间:</div>
              <div class="val">{{invoiceInfo.createTime}}</div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="name">发票类型:</div>
              <div class="val">增值税专票</div>
            </div>
            <div class="item">
              <div class="name">发票内容:</div>
              <div class="val">*物业服务*会议室预定</div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="name">发票抬头:</div>
              <div class="val">单位</div>
            </div>
            <div class="item">
              <div class="name">单位名称:</div>
              <div class="val">{{invoiceInfo.name}}</div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="name">纳税人识别号:</div>
              <div class="val">{{invoiceInfo.taxpayerCode}}</div>
            </div>
            <div class="item">
              <div class="name">注册地址:</div>
              <div class="val">{{invoiceInfo.address}}</div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="name">注册电话:</div>
              <div class="val">{{invoiceInfo.mobile}}</div>
            </div>
            <div class="item">
              <div class="name">开户银行:</div>
              <div class="val">{{invoiceInfo.bank}}</div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="name">银行账号:</div>
              <div class="val">{{invoiceInfo.bankCode}}</div>
            </div>
          </div>
        </div>
        <div class="btn">
          <el-button type="primary" @click="showInvoiceDialog = false">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import Nav from '@/components/nav'
import utils from '@/jslib/utils'
import { getAppointmentList, appointmentExcel, putMeetingAppointment, getInvoice } from '@/api/meeting'
import { getIndustrySelectList } from '@/api/industry'
import TablePagination from '@/components/table-pagination'
export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'meetingAppointmentManagement',
  data() {
    return {
      showInvoiceDialog: false,
      updateParams: {
        meetingTitle: '',
        uuid: ''
      },
      body: {
        word: '',
        pageSize: 10,
        pageIndex: 1,
        status: null,
        startTime: '',
        endTime: '',
        userUuid: '',
        industryUuid: ''
      },
      putMeetingBody: {
        uuid: '',
        status: null
      },
      excelBody: {
        status: '',
        word: '',
        industryUuid: '',
      },
      titleBox: [
        {
          name: '全部',
          status: null,
          select: true
        },
        {
          name: '待审核',
          status: 0,
          select: false
        },
        {
          name: '未开始',
          status: 1,
          select: false
        },
        {
          name: '进行中',
          status: 2,
          select: false
        },
        {
          name: '已结束',
          status: 3,
          select: false
        },
        {
          name: '已取消',
          status: 4,
          select: false
        }
      ],
      config: {
        size: 10,
        fields: [
          {
            prop: 'createTime',
            label: '下单时间'
          },
          {
            prop: 'industryName',
            label: '所在产业'
          },
          {
            prop: 'meetingTitle',
            label: '会议标题'
          },
          {
            prop: 'orderNum',
            label: '订单编号'
          },
          {
            prop: 'enterpriseName',
            label: '企业'
          },
          {
            prop: 'title',
            label: '会议室'
          },
          {
            prop: 'reservationDate',
            label: '预约日期'
          },
          {
            prop: 'reservationTime',
            label: '预约时段'
          },
          // {
          //   prop: 'amount',
          //   label: '支付金额（元）'
          // },
          {
            prop: 'status',
            label: '状态',
            type: 'status',
            rule: [
              {
                value: 0,
                label: '待审核'
              },
              {
                value: 1,
                label: '未开始'
              },
              {
                value: 2,
                label: '进行中'
              },
              {
                value: 3,
                label: '已结束'
              },
              {
                value: 4,
                label: '已取消'
              }
            ]
          },
          {
            prop: 'isInvoice',
            label: '是否开票',
            type: 'status',
            rule: [
              {
                value: 0,
                label: '否'
              },
              {
                value: 1,
                label: '是'
              }
            ]
          }
        ]
      },
      datasource: {
        total: 0,
        data: []
      },
      industryList: [],
      selectIndustry: '',
      invoiceInfo: {},
    }
  },
  mounted() {
    this.network().getAppointmentList()
    this.network().getIndustrySelectList()
  },
  methods: {
    event() {
      return {
        search: () => {
          this.network().getAppointmentList()
        },
        changeStatus: (e) => {
          this.event().clearStatus()// 清除
          e.select = true// 赋值
          this.body.status = e.status
          this.network().getAppointmentList()
        },
        clearStatus: () => {
          this.titleBox.forEach(item => {
            item.select = false
          })
        },
        putMeetingAppointment: (status, scope) => {
          if (status === 1) {
            this.$confirm('是否通过？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.putMeetingBody.uuid = scope.row.uuid
              this.putMeetingBody.status = status
              this.network().putMeetingAppointment()
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作'
              })
            })
          } else if (status === 4) {
            this.$confirm('是否拒绝？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.putMeetingBody.uuid = scope.row.uuid
              this.putMeetingBody.status = status
              this.network().putMeetingAppointment()
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作'
              })
            })
          }
        }
      }
    },
    network() {
      return {
        getAppointmentList: async() => {
          const { data } = await getAppointmentList(this.body)
          this.datasource.total = data.total
          this.datasource.data = data.list
        },
        appointmentExcel: async() => {
          this.excelBody.status = this.body.status
          this.excelBody.word = this.body.word
          this.excelBody.industryUuid = this.body.industryUuid
          const { data } = await appointmentExcel(this.excelBody)
          utils.exportExcel(data, '导出会议室预约excel')
        },
        putMeetingAppointment: async() => {
          await putMeetingAppointment(this.putMeetingBody)
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.network().getAppointmentList()
        },
        getIndustrySelectList: async() => {
          const { data } = await getIndustrySelectList()
          data.forEach(item => {
            this.industryList.push({
              value: item.uuid,
              label: item.name
            })
          })
        },
        getInvoice: async(uuid)=>{
          let { data } = await getInvoice(uuid)
          this.invoiceInfo = data
          this.showInvoiceDialog = true
        }
      }
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getAppointmentList()
    },
    handlerPage(type, scope) {
      this.$router.push({
        path: `/metting-management/appointment-management/get/${scope.row.uuid}`
      })
    },
    handleIndustry() {
      this.body.industryUuid = this.selectIndustry
      this.body.pageIndex = 1
      this.network().getAppointmentList()
    },
    hanlderInvoicing(row){
      this.network().getInvoice(row.uuid)
    }
  },
  components: {
    Nav,
    TablePagination
  }
}
</script>

<style scoped lang="scss">
.type-change-box{
  margin: 15px 0;
  display: flex;
  .box-name{
    font-size: 20px;
    font-weight: bold;
    margin-right: 60px;
    color: rgb(163, 159, 159);
    span{
      cursor: pointer;
    }
  }
  .black{
    color: black;
  }
}

Nav{
  margin-bottom: 10px;
  .industry-box{
    margin-left: 90px;
    span{
      margin-right: 15px;
    }
  }
}

/deep/ .table{
  /deep/ .el-table__body .el-table__row{
    height: 80px;
  }
}


/deep/.el-dialog{
    /deep/.el-dialog__header {
      padding: 0;
    }
    /deep/.el-dialog__body{
      padding: 0;
    }
}
.dialog-content{
  padding-bottom: 30px;
  .title{
    padding: 20px 30px;
    text-align: center;
    background: #f2f2f2;
  }
  .person{
    height: 300px;
    margin: 30px 0;
    padding: 0 30px;
  }
  .company{
    height: 300px;
    margin: 30px 0;
    padding: 0 30px;
  }
  .row{
    display: flex;
    margin: 30px 0;
    .item{
      width: 50%;
      display: flex;
      .name{
        white-space: nowrap;
        margin-right: 15px;
        color: #999;
      }
    }
  }
  .btn{
    display: flex;
    justify-content: center;
  }
}
</style>
